import { createReducer } from '@reduxjs/toolkit';

import { loadCommissionsStart, loadCommissionsSuccess, resetCommissions } from './actions';
import { ICommissionData, ICommissionsReducer } from './types';

const initialState: ICommissionsReducer = {
  isLoading: false,
  isLoaded: false,
  data: {} as ICommissionData,
};

const CommissionsReducer = createReducer(initialState, (builder) => {
  builder
    .addCase(loadCommissionsStart, (state) => ({ ...state, isLoading: true }))
    .addCase(loadCommissionsSuccess, (state, action) => ({ ...state, isLoading: false, isLoaded: true, data: action.payload }))
    .addCase(resetCommissions, () => initialState);
});

export default CommissionsReducer;
